<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">投訴類型設置</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>
            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(row)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(row)">删除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                  <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    </div>
</template>

<script>
   export default {
      data() {
         return {
            pageIndex: 1,
            curPageSize: 10,
            pageInput: '',
            isSubmiting: false,
            totalCount: 0,
            table: {
               column: [
                  {
                     title: '類型',
                     key: 'type',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '文案內容',
                     key: 'text_content',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '狀態',
                     key: 'status',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '排序',
                     key: 'sort',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '更新時間',
                     key: 'updated_at',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '操作',
                     slot: 'action',
                     align: 'center',
                     minWidth: 150
                  }
               ],
               data: []
            }
         };
      },
      activated() {
         this.getList();
      },
      mounted() {
         this.getList();
      },
      methods: {
         getList() {
            let form = this.form;
            this.isSubmiting = true;
            this.$Rq.requestAuth({
               url: this.$Api.complaintManageList,
               method: 'get',
               data: {
                id: '',
               }
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 0) {
                  let tempArr = [];
                  let resData = res.data.data;
                  for (let i = 0; i < resData.length; i++) {

                     if(resData[i].status == 1){
                        resData[i].status = '開啟';
                     }else{
                        resData[i].status = '關閉';
                     }

                     if(resData[i].type == 1){
                        resData[i].type = '投訴';
                     }else if(resData[i].type == 2){
                        resData[i].type = '催單';
                     }

                     tempArr.push({
                        id: resData[i].id,
                        sort: resData[i].sort,
                        status: resData[i].status,
                        text_content: resData[i].text,
                        type: resData[i].type,
                        created_at: resData[i].created_at == null ? '- - -' : resData[i].created_at,
                        updated_at: resData[i].updated_at == null ? '- - -' : resData[i].updated_at,
                     });
                  }
                  this.totalCount = res.data.count;
                  this.table.data = tempArr;
               } else {
                  this.showTipInfo(res.msg);
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },
         handleDelete(item) {
            let id = item.id;
            this.$Modal.confirm({
               title: '提示',
               content: '確定刪除嗎？',
               cancelText: '取消',
               okText: '確定',
               onOk: () => {
                  let tableData = this.table.data;
                  this.isSubmiting = true;
                  this.$Rq.requestAuth({
                     url: this.$Api.complaintManageListDel,
                     method: 'post',
                     data: {
                      id: id,
                     }
                  }).then((res) => {
                     this.isSubmiting = false;
                     if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.getList();
                     } else {
                        this.$Utils.showTipInfo(res.msg);
                     }
                  }).catch((err) => {
                     this.isSubmiting = false;
                  });
               }
            });
         },
         handleToAdd() {
            this.$router.push({path: '/complaintManageAdd'});
         },
         handleSearch() {
            this.pageIndex = 1;
            this.getList();
         },
         handleEdit(item) {
            this.$router.push({path: '/complaintManageEdit?id=' + item.id})
         },
         handlePageSizeChange(value) {
            this.pageIndex = 1;
            this.getList();
         },
         handlePageInput() {
            let value = ('' + this.pageInput).replace(/\D/g, '');
            let pageCount = Math.ceil(this.totalCount / this.curPageSize);
            if (value > pageCount) {
               value = pageCount;
            }
            this.pageInput = value;
         },
         handlePageEnter() {
            if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
            if (this.pageInput == 0) {
               this.pageInput = 1;
            }
            this.pageInput = parseInt(this.pageInput);
            this.pageIndex = this.pageInput;
            this.getList();
         },
         handlePageChange(value) {
            this.pageIndex = value;
            this.getList();
         }
      }
   };
</script>

<style lang="scss" scoped>
    @import 'complaintManage.scss';
</style>